/* eslint-disable no-console, no-undef */
import {
    ADD_TO_CART, CLEAR_CART, REMOVE_FROM_CART, UPDATE_CART_ITEM_QUANTITY,
} from './actions';
import cartToGTagProductFormatItems from '../../utils/cartToGTagProductFormatItems';


export default (state, action) => {
    switch (action.type) {
    case ADD_TO_CART: {
        console.log('adding to cart');
        console.log(action);
        const { product, quantity } = action;

        let alreadyExistedInCart = false;
        let updatedCart = state.cart.map((cartItem) => {
            if (cartItem.product.variant.id === product.variant.id) {
                alreadyExistedInCart = true;
                return {
                    product,
                    quantity: cartItem.quantity + quantity,
                };
            }

            return cartItem;
        });

        if (!alreadyExistedInCart) {
            updatedCart = [...state.cart, {
                product,
                quantity,
            }];
        }

        console.log('A');
        if (process.env.GATSBY_ACTIVE_ENV === 'production') {
            console.log('b');
            // eslint-disable-next-line no-restricted-syntax
            gtag('event', 'add_to_cart', {
                items: cartToGTagProductFormatItems(updatedCart),
            });
        }

        return {
            ...state,
            cart: updatedCart,
        };
    }


    case REMOVE_FROM_CART: {
        const itemToRemove = state.cart.filter(
            cartItemPotential => cartItemPotential.product.variant.id === action.product.variant.id,
        );
        const updatedCart = state.cart.filter(
            cartItemPotential => cartItemPotential.product.variant.id !== action.product.variant.id,
        );

        if (updatedCart.length === 0) {
            // eslint-disable-next-line no-undef
            document.getElementsByClassName('shopping-cart-quickview')[0].classList.remove('is-active');
        }
        if (process.env.GATSBY_ACTIVE_ENV === 'production') {
            gtag('event', 'remove_from_cart', {
                items: cartToGTagProductFormatItems(itemToRemove),
            });
        }

        return {
            ...state,
            cart: updatedCart,
        };
    }

    case UPDATE_CART_ITEM_QUANTITY: {
        const { product, quantity } = action;
        const updatedCart = state.cart.map((cartItem) => {
            if (cartItem.product.variant.id === product.variant.id) {
                return {
                    product,
                    quantity: Number(quantity),
                };
            }


            return cartItem;
        });

        return {
            ...state,
            cart: updatedCart,
        };
    }

    case CLEAR_CART: {
        if (process.env.GATSBY_ACTIVE_ENV === 'production') {
            gtag('event', 'remove_from_cart', {
                items: cartToGTagProductFormatItems(state.cart),
            });
        }

        return {
            ...state,
            cart: [],
        };
    }


    default:
        return state;
    }
};
